import InformationBanner from './InformationBanner';
import { EmploymentDateInputForm, EmploymentSalaryInputForm } from './EmploymentInputs';
import { useForm } from 'react-hook-form';
import Icon from '@mdi/react';
import { useGetEmploymentTypes } from '@my-pages/features/employment/hooks/queries.ts';
import { IEmploymentInfo } from '@shared/integrations/taf-api/v2/models';
import { formatDate, getLastDayOfNextYear, getStartOfNextMonth, getStartOfPreviousMonth } from '@shared/utils/dateUtils';
import { mdiFileDocumentEditOutline } from '@mdi/js';
import useEmploymentFormActions from '@my-pages/features/employment/hooks/useEmploymentFormActions.ts';
import { useGetPerson } from '@my-pages/hooks/useGetPerson.ts';
import {employmentType} from "@my-pages/features/employment/services/EmploymentService.ts";
import {EmploymentUpdateStatus} from "@my-pages/features/employment/types";

interface IStudyForm {
    employment: IEmploymentInfo;
    closeForm: () => void;
    setDisplayMessage: (value: EmploymentUpdateStatus | null) => void;
}

export const StudyForm = ({ employment, closeForm, setDisplayMessage }: IStudyForm) => {
    const getEmploymentTypes = useGetEmploymentTypes();
    const person = useGetPerson();

    const { updateEmployment } = useEmploymentFormActions();
    const {
        handleSubmit,
        register,
        control,
        formState: { isValid },
        getValues,
        watch,
    } = useForm({ mode: 'onChange' });
    watch(['startDateStudent', 'endDateStudent']);

    const submit = async (submitData: any) => {
        const submitDataWithDefaultData = {
            ...submitData,
            //description: StudyDescription(submitData),
            salary: Number(submitData.salary),
            employmentId: employment?.employmentId,
            //@ts-ignore
            employementStatusId: getEmploymentTypes?.employmentTypes?.[employmentType.student] || '',
            startDateStudent: formatDate(submitData.startDateStudent),
            endDateStudent: formatDate(submitData.endDateStudent),
            memberId: person.id,
            workplaceId: employment?.workplaceId,
        };

        const result = await updateEmployment(submitDataWithDefaultData);
        setDisplayMessage(result);
        closeForm();
    };

    return (
        <form onSubmit={handleSubmit(submit)}>
            <h3 className='d-flex'>
                <Icon
                    path={mdiFileDocumentEditOutline}
                    className='mdi mdi-36 mr-2 mt-n2'
                />
                <span>Har du blivit studerande?</span>
            </h3>
            <p className='required-info'>* Obligatoriska uppgifter</p>
            <EmploymentSalaryInputForm
                name='salary'
                register={{ ...register('salary', { required: true }) }}
            />
            <h4 className='mt-5'>Välj period</h4>
            <EmploymentDateInputForm
                control={control}
                rules={{ required: true }}
                minDate={getStartOfNextMonth()}
                maxDate={getStartOfPreviousMonth(getValues('endDateStudent'))}
                name='startDateStudent'
            />
            <EmploymentDateInputForm
                control={control}
                rules={{ required: true }}
                endOfMonth={true}
                label={'Till och med'}
                minDate={getStartOfNextMonth(getValues('startDateStudent'))}
                maxDate={getLastDayOfNextYear(new Date())}
                name='endDateStudent'
            />
            <InformationBanner />
            <div className='d-flex justify-content-sm-end mt-5 mb-4'>
                <button
                    className='btn btn-light btn-lg mr-3'
                    type='button'
                    onClick={() => closeForm()}
                >
                    Avbryt
                </button>
                <button
                    className='btn btn-primary btn-lg'
                    disabled={isValid ? false : true}
                >
                    Spara
                </button>
            </div>
        </form>
    );
};
